import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { RootLayout } from '@/layouts/RootLayout';
import { AuthLayout } from '@/layouts/AuthLayout';
import { DashboardLayout } from '@/layouts/DashboardLayout';
import { ProtectedRoute } from '@/shared/components/ProtectedRoute';
import { OpenPanelRouteTracking } from '@/shared/analytics/OpenPanelRouteTracking';
import * as ROUTES from '@/shared/constants/routes';

// Landing page
import { LandingPage } from '@/features/landing/pages/LandingPage';

// Auth pages
import { LoginPage, MfaPage } from '@/features/auth/pages/LoginPage';
import { ForgotPasswordPage } from '@/features/auth/pages/ForgotPasswordPage';
import { ResetPasswordPage } from '@/features/auth/pages/ResetPasswordPage';
import AdminInvitePage from '@/features/auth/pages/AdminInvitePage';

// Dashboard pages
import { DashboardPage } from '@/features/dashboard/pages/DashboardPage';

// Transfers pages
import { TransfersPage } from '@/features/transfers/pages/TransfersPage';

// Tarjeta pages
import { CardPage } from '@/features/card/pages/CardPage';
import { CardDetailPage } from '@/features/card/pages/CardDetailPage';
import { CardTrackingPage } from '@/features/card/pages/CardTrackingPage';

// Team pages
import { TeamPage } from '@/features/team/pages/TeamPage';

// Credits pages
import { CreditsPage } from '@/features/credits/pages/CreditsPage';

// Onboarding pages
import { OnboardingInvitePage } from '@/features/onboarding/pages/OnboardingInvitePage';
import { OnboardingUserPage } from '@/features/onboarding/pages/OnboardingUserPage';

export function AppRouter() {
  return (
    <BrowserRouter>
      <OpenPanelRouteTracking />
      <Routes>
        <Route element={<RootLayout />}>
          {/* Public routes */}
          <Route path={ROUTES.DEFAULT} element={<LandingPage />} />
          <Route element={<AuthLayout />}>
            <Route path={ROUTES.LOGIN} element={<LoginPage />} />
            <Route path={ROUTES.MFA} element={<MfaPage />} />
            <Route path={ROUTES.FORGOT_PASSWORD} element={<ForgotPasswordPage />} />
            <Route path={ROUTES.RESET_PASSWORD} element={<ResetPasswordPage />} />
            <Route path={ROUTES.ADMIN_INVITE} element={<AdminInvitePage />} />
            <Route path={ROUTES.ONBOARDING_INVITE} element={<OnboardingInvitePage />} />
            <Route path={ROUTES.ONBOARDING_USER} element={<OnboardingUserPage />} />
            <Route path={ROUTES.USER_INVITATION_VALIDATE_V1} element={<OnboardingInvitePage />} />
          </Route>

          {/* Protected routes */}
          <Route element={<ProtectedRoute />}>
            <Route element={<DashboardLayout />}>
              <Route path={ROUTES.DASHBOARD} element={<DashboardPage />} />
              <Route path={ROUTES.CARD} element={<CardPage />} />
              <Route path={ROUTES.CARD_DETAIL} element={<CardDetailPage />} />
              <Route path={ROUTES.TRANSFERS} element={<TransfersPage />} />

              {/* Specific permissions */}
              <Route element={<ProtectedRoute permission="CARD_TRACKING_DETAIL" />}>
                <Route path={ROUTES.CARD_TRACKING_DETAIL} element={<CardTrackingPage />} />
              </Route>
              <Route element={<ProtectedRoute permission="VIEW_TEAM_MENU" />}>
                <Route path={ROUTES.TEAM} element={<TeamPage />} />
              </Route>
              <Route element={<ProtectedRoute permission="VIEW_CREDIT_MENU" />}>
                <Route path={ROUTES.CREDITS} element={<CreditsPage />} />
              </Route>
            </Route>
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
